import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the Confluence Deep Research page creation command.
 */

/**
 * Command to request creation of a Confluence page using the Deep Research export payload.
 */
export var ConfluenceDeepResearchPageCreateCommand = createCommand('confluence-deep-research-page-create-command');